module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("French Desserts")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("Essential Ingredients ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e155"
    }
  }, [_vm._v("On the pantry shelf\n              ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e343"
    }
  }, [_vm._v("In the freezer or refrigerator\n                ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Essential Tools ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homey Cakes ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e603",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plenty of Pears Salted Caramel\n                  Loaf Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e673",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Wheat Nutella Loaf Cake\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e739",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tart Lime and Yogurt Loaf Cake\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e829",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wine and Grape Harvest Loaf Cake\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e903",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini, Lemon, and Walnut Loaf\n                  Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e954",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Glazed Apricot Almond\n                  Loaf Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crazy Chocolate Loaf Cake with\n                  Fleur de Sel and Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hélène’s Grandmother’s Rice\n                  Pudding Cake Bathed in Caramel ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hazelnut Cake with Nutella\n                  Drizzle ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Normandy Apple Cake Tatin Style\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walnut Cake with Warm Honey\n                  Glaze ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fabulous Butter Cake from\n                  Brittany ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#eiffel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eiffel Tower Pie Crust Cookies\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1533",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Domes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1617",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Seed Tuiles\n              ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1673",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irresistible Espresso Almond\n                  Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#broye",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giant Break-and-Share Cookie\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1778",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Sables\n              ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1823",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laughing Cow Sugar Cookies\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#palets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Palets de Dames with Currants or\n                  Chocolate Chips ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1936",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anise Cookies with Pistachios\n                  and Dried Cherries ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1993",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Boat Cookies from\n                  Marseille ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Madeleines with Orange\n                  Glaze ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breton Butter Cookies\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#lunette",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot Jam “Eyeglasses”\n                  Cookies ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Fruit Papillotes with\n                  Melting Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Flaugnarde\n              ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Banana and Chocolate Pain\n                  Perdu ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Peaches in a Pool of\n                  Crème Anglaise ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2494",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Individual Berries Gratin with\n                  Yogurt Whipped Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Sugar Bread Ardennaise\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2631",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puffs with Warm Chocolate Sauce\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2705",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Far Breton Prune Custard Cake\n                ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verrines ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2773",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cloud of Lemon Vermouth\n                  Mousse ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2819",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Très Quick Chocolate Ginger\n                  Pots de Crème ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2864",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberries Romanoff\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2910",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh and Dried Fruit Salad in\n                  Sweet Basil Syrup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2974",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grand Marnier Mousse\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e3029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Wine Jelly, Wine Whipped\n                  Cream, and Grapes on the Vine ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e3072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Rice Pudding with\n                  Blackberry Caramel Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e3142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Provençal Melon Mousse\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e3200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chambord Raspberry and White\n                  Chocolate Mousse ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e3241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blanc-Manger with Apricot\n                  Coulis ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen or Refrigerated Desserts\n          ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e3327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Vin Chaud” Sorbet with Frosted\n                  Grapes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#froyo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Frozen Yogurt\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e3440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Melba with Muddled\n                  Vanilla Ice Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e3516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Orange Sorbet Champagne\n                  Coupe ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e3570",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Left Bank Café Liégeois\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e3622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Sorbet with Fresh Peach\n                  Slices ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e3659",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla, Raspberry, and\n                  Chocolate Ice Cream Bombe Glacée ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waffles, Crêpes, and Pancakes ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e3742",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Street Fair Lemon Waffles with\n                  Blueberries and Chantilly ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e3816",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farz Buen Broken Crêpes\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e3853",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green and Red Apple Pancake\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e3916",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Orange Crêpes Suzette\n                ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puff Pastry ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e4017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Niflettes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e4082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Raspberry Croissants\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e4116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastry Shop Traditional Almond\n                  Pithivier ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e4188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot Jam Sacristans\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e4227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giant Strawberry-and-Whipped\n                  Cream Millefeuille ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e4281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alsatian Apple Marzipan Strudel\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e4347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Vol-au-Vent with a\n                  Strawberry and Tarragon Coulis ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tarts ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e4452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rustic Plum Tart in a Sweet\n                  Fennel Crust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e4541",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medieval Custard Tart in a\n                  Clove-Scented Crust ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e4619",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Peach Galette\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e4721",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate on Chocolate Tart\n                  with Raspberries ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e4795",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swiss Chard and Goat Cheese\n                  Cheesecake Tart ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candies and Mignardises ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4920",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Chocolate Truffles with\n                  Dried Cherries and Chocolate Whiskey Truffles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4995",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Pain d’Épices\n              ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e5075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Orangettes with Chocolate\n                  Squiggles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e5136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swirly Marshmallows\n              ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#nonnette",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nonnettes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e5270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond–Brown Butter Financiers\n                ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Occasion Desserts ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#pavlova",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pavlova with Mixed Berries\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#souffle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Soufflé\n              ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#brulee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Chocolate Crèmes Brûlées\n                  with Salty Pistachios ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#pastis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastis Gascon ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#charlotte",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Precious Pear Charlotte\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#almond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valbonnaise Almond Tart\n                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e5802",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silky Chocolate Jelly with\n                  Berries and Whipped Cream ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#rum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baba au Rhum ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b4cf77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0